// extracted by mini-css-extract-plugin
export var arrow = "Button-module--arrow--1d1aa";
export var blueBorder = "Button-module--blueBorder--6eedf";
export var button = "Button-module--button--c17ef";
export var colorAzure = "Button-module--colorAzure--dda51";
export var colorBlue = "Button-module--colorBlue--fe74e";
export var colorGradientSeafoam = "Button-module--colorGradientSeafoam--2ee5c";
export var colorGreen = "Button-module--colorGreen--292db";
export var colorLightBlue = "Button-module--colorLightBlue--d0311";
export var colorTransparent = "Button-module--colorTransparent--69f45";
export var colorWhite = "Button-module--colorWhite--c80f7";
export var exlarge = "Button-module--exlarge--bd6f3";
export var large = "Button-module--large--e508c";
export var link = "Button-module--link--c7764";
export var long = "Button-module--long--4a07a";
export var regular = "Button-module--regular--5dce5";
export var rounded = "Button-module--rounded--0633f";
export var small = "Button-module--small--c0339";
export var text = "Button-module--text--38ccd";